/**
 * "New since your last visit": a returning player who opens a story sees, once, the changes from players' feedback
 * (changes.ts) made since their last turn in it. Remembered per browser; if storage is blocked it never shows, rather
 * than showing every time.
 */
import { FROM_FEEDBACK, type Change } from "./changes";

const SEEN_KEY = "weftwake.changes-seen";

/** The changes made on or after the day of the last turn (a day's change may have come after it), newest first, not yet seen. */
export function changesSince(lastAt: number | null, seen: string | null, list: Change[] = FROM_FEEDBACK): Change[] {
  if (!lastAt) return [];
  const lastDay = new Date(lastAt).toISOString().slice(0, 10);
  return list.filter((c) => c.date >= lastDay && (!seen || c.date > seen));
}

/** The changes to show for a story last played at `lastAt`, marked seen as they're returned (shown once). */
export function takeNewSince(lastAt: number | null): Change[] {
  try {
    const fresh = changesSince(lastAt, localStorage.getItem(SEEN_KEY)).slice(0, 3);
    if (FROM_FEEDBACK[0]) localStorage.setItem(SEEN_KEY, FROM_FEEDBACK[0].date);
    return fresh;
  } catch {
    return [];
  }
}
